import { atom } from 'recoil';
import { TaskOutput } from '~/backend/connector-api/connector-schemas';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';

type AutoSegmentationTaskState = {
    model?: GenerationModelDetails;
    customizationName?: string;
    subSelectedStructures?: string[];
    output?: TaskOutput;
    polling?: boolean;
    includeStructureSet?: boolean;
};

export const autoSegmentationTaskState = atom<AutoSegmentationTaskState>({
    key: 'autoSegmentationTaskState',
    default: undefined,
});
